module.exports = __webpack_public_path__ + "img/shape03.464a1206.svg";